'use client';

import { createContext } from 'react';
import type { WizardContextValue, WizardState } from '../types';

/**
 * Initial state for the wizard
 */
export const initialWizardState: WizardState = {
  // Session
  sessionId: null,
  currentStepIndex: 0,
  completedSteps: [],

  // Form data
  formData: {},

  // Salesforce IDs
  leadId: null,
  contactId: null,
  accountId: null,
  opportunityId: null,

  // UI state
  isLoading: true,
  isSaving: false,
  error: null,
};

/**
 * Context for wizard state management
 */
export const WizardContext = createContext<WizardContextValue | null>(null);
